import ERROR_MESSAGES from 'constants/error-messages.const';
const hasBigCharRegex = /(?=.*?[A-Z])|(?=.*?[ĞÜŞÖÇİ])/;
const hasLowCharRegex = /(?=.*?[a-z])|(?=.*?[wığüşöç])/;
const hasNumberRegex = /(?=.*?[0-9])/;
const isMisdnRegex = /5\d{9}$/;
export const isAlphabeticRegex =/^[a-zA-Z\sğüşöçİĞÜŞÖÇ]*$/;

export const validateWithRegex = async (regex, message, value) => {
  const has = regex.test(value);
  if (has && value) return Promise.resolve();
  return Promise.reject(message);
};
export default {
  hasBigChar: (rule, value) =>
    validateWithRegex(hasBigCharRegex, ERROR_MESSAGES.mustBigChar, value),
  hasLowChar: (rule, value) =>
    validateWithRegex(hasLowCharRegex, ERROR_MESSAGES.mustLowChar, value),
  hasNumber: (rule, value) =>
    validateWithRegex(hasNumberRegex, ERROR_MESSAGES.mustNumber, value),
  isMsisdn: (rule, value) =>
    validateWithRegex(isMisdnRegex, ERROR_MESSAGES.mustMsisdn, value),
  isAlphabetic: (rule, value) =>
    validateWithRegex(isAlphabeticRegex, ERROR_MESSAGES.isAlphabetic, value),
  minLength: (rule, value, length) =>
    value && value.length >= 6
      ? Promise.resolve()
      : Promise.reject(ERROR_MESSAGES.min(length)),
};
